import styled from "styled-components";

export const DetailsHeader = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-between;
`

export const WrapperDetail = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`
